import { NgFor } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';

import { MarketTab } from '../bet-builder-event-model';

@Component({
    selector: 'ms-market-list-header',
    templateUrl: './market-list-header.component.html',
    styleUrls: ['./market-list-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgFor, ScrollAdapterComponent],
})
export class MarketListHeaderComponent implements OnInit, OnChanges {
    @Input() marketTabs: MarketTab[];
    @Output() tabClicked = new EventEmitter<string>();

    selectedMarketTab: MarketTab;

    ngOnInit(): void {
        if (this.marketTabs?.length) {
            this.selectedMarketTab = this.marketTabs[0];
        }
    }

    ngOnChanges(): void {
        if (!this.marketTabs?.some((t) => t.id === this.selectedMarketTab?.id)) {
            this.selectedMarketTab = this.marketTabs[0];
        }
    }

    tabSelected($event: Event, tab: MarketTab): void {
        this.selectedMarketTab = tab;
        this.tabClicked.emit(tab.id);
    }

    trackItem(index: number, tab: MarketTab): string {
        return `${tab.id}${tab === this.selectedMarketTab}`;
    }
}
